<template>
  <section class="flex min-h-screen flex-col bg-white lg:bg-gray-50">
    <AppHeader class="sticky top-0" />
    <main role="main" class="mx-auto flex max-w-7xl flex-1 items-center">
      <NuxtLoadingIndicator color="#0885F2" />
      <NuxtPage />
    </main>
  </section>
</template>
